import * as React from 'react';
import { ChartFactory, TChartFactoryProps } from '@cian/react-chartjs-component';
import { IControlOption, RadioGroup } from '@cian/ui-kit';
import { ERoomType } from '../../../types/realtyValuation';
import * as styles from './styles.css';

interface IPriceGraphProps {
  chartCfg: TChartFactoryProps;
  roomType: ERoomType;
  roomOptions: IControlOption[];
  onChange(e: React.ChangeEvent<HTMLInputElement>, type: ERoomType): void;
}

export function PriceChart({ chartCfg, onChange, roomType, roomOptions }: IPriceGraphProps) {
  return (
    <>
      <div className={styles['filters']}>
        <RadioGroup
          horizontal
          name="valuation-price-chart-rooms-filter"
          value={roomType}
          onChange={onChange}
          options={roomOptions}
        />
      </div>
      <div className={styles['graph']}>
        <ChartFactory {...chartCfg} />
      </div>
    </>
  );
}
